import type { HealthierSGState } from '../types/healthierSG.types';

export const initialState: HealthierSGState = {
  additionalExerciseNotes: [],
  enrollmentInfo: null,
  filteredClinicsSearch: null,
  healthPlanHistory: {
    data: null,
    errorCode: null,
    errorMsg: null,
    isLoading: false,
    selected: {
      id: null,
      versionId: null,
    },
    total: 0,
  },
  hsgBookAppointment: {
    banner: null,
    hasExistingAppointment: null,
    hasMissedAppointment: null,
    hsgValidateRequest: null,
    isHasClinic: null,
    isHSGBookHealthConsultation: false,
    isScreeningAppointment: null,
    isServiceAvailable: null,
    isVaccination: false,
    isVaccineGroup: null,
    offeringId: null,
    pcpInfo: null,
    returnUrl: null,
  },
  isFromGetVaccinatedPage: false,
  isFromHSGRequestFormPage: false,
  kakiBadge: false,
  lifestyle: {
    articleCode: '',
  },
  screeningInfo: null,
  screeningInfoForBookAppt: null,
  selectedActivity: null,
  selectedClinic: null,
  selectedSmokingAnswer: null,
  selectedExercise: null,
  selectedExerciseDay: null,
};
